import Button from 'assets/components/button/Button';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import { addLog } from 'assets/components/feedback/Feedback';
import Icon from 'assets/components/icon/Icon';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperPaper from 'assets/themes/wrappers/Theme.Wrapper.Paper';
import { HttpStatus } from 'config/Api.Config';
import { first } from 'lodash';
import { useState } from 'react';
import { useAccountReceivableProvider } from '../../Finance.AccountReceivable.Hooks';

export default function FinanceAccountReceivableInfoDocuments() {
  const { lang } = getLocales();
  const { selected, findApi } = useAccountReceivableProvider();
  const [file, setFile] = useState<Hooks.Input.File.Info>();
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const uploadChequeDocument = async () => {
    if (!file?.original) return;
    setIsUploading(true);
    const res = await selected.uploadChequeDocument({ formFile: file.original });
    setIsUploading(false);

    if (res.status !== HttpStatus.ok) addLog({ error: res.message || lang.unknownError });
    else {
      addLog({ success: lang.saveSuccess });
      setFile(null);
      findApi.execute((body) => body);
    }
  };

  const deleteChequeDocument = async () => {
    if (!selected.chequeDocumentId) return;
    setIsDeleting(true);
    const res = await selected.deleteChequeDocument(selected.chequeDocumentId);
    setIsDeleting(false);

    if (res.status !== HttpStatus.ok) addLog({ error: res.message || lang.unknownError });
    else {
      addLog({ success: lang.wereSuccessfullyDeleted });
      findApi.execute((body) => body);
    }
  };

  return (
    <>
      <br />
      <Card
        class={ThemeCardRow}
        title={lang.evidenceDocument}
        info={selected.evidenceDocument?.name || lang.noFiles}
        subtitle={selected.evidenceDocument?.url}
        media="fas-file-alt"
        actions={
          <LinkButton
            class={ThemeButtonCircle}
            url={selected.evidenceDocument?.url}
            media={<Icon class="fas-download" />}
            target="_blank"
            disabled={!selected.evidenceDocument?.url}
            htmlElementProps={{ title: lang.download }}
          />
        }
      />
      <Card
        class={ThemeCardRow}
        title={lang.chequeDocument}
        info={selected.chequeDocument?.name || lang.noFiles}
        subtitle={selected.chequeDocument?.url}
        media="fas-file"
        actions={
          <>
            <LinkButton
              class={ThemeButtonCircle}
              url={selected.chequeDocument?.url}
              media={<Icon class="fas-download" />}
              target="_blank"
              disabled={!selected.chequeDocument?.url}
              htmlElementProps={{ title: lang.download }}
            />
            <Button
              class={ThemeButtonCircle}
              onClick={deleteChequeDocument}
              media="fas-trash"
              disabled={!selected.chequeDocumentId}
              isLoading={isDeleting}
              htmlElementProps={{ title: lang.delete }}
            />
          </>
        }
      />
      <br />
      <FormWrapper class={ThemeWrapperPaper}>
        <h3>{lang.chequeDocument}</h3>
        <FileInput
          name="file"
          fileLimit={1}
          value={file ? [file] : []}
          onChange={({ file }) => setFile(first(file))}
          class={ThemeFileInputDropzone}
          disabled={!!selected.chequeDocumentId}
        />
        {!file && <ErrorWrapper children={lang.noFiles} />}
        <Button
          render={lang.add}
          media="fas-upload"
          onClick={uploadChequeDocument}
          disabled={!file?.original || !!selected.chequeDocumentId}
          isLoading={isUploading}
          active={!!file?.original}
          class={ThemeButtonCircle}
          htmlElementProps={{ title: lang.add }}
        />
      </FormWrapper>
    </>
  );
}
